export const useHeadTitle = (t?: string | null) => t ? `${t} - Yescapa blog` : 'Yescapa Blog'
